import { ApiCrud } from 'adready-api/api/api-crud';
import http from 'adready-api/api/http';

const publisherMediaTypeApi = new ApiCrud(http.AXIOS, {
  deletePublisherMediaType: 'DELETE mediaTypes/:id',
});

export default publisherMediaTypeApi;
